import { type NewCoreIconProps } from '@atlaskit/icon';
import ArrowsDiagonalUpRightDownLeftIcon from '@atlaskit/icon-lab/core/arrows-diagonal-up-right-down-left';
import BookOpenIcon from '@atlaskit/icon-lab/core/book-open';
import LozengeIcon from '@atlaskit/icon-lab/core/lozenge';
import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import ArrowUpRightIcon from '@atlaskit/icon/core/arrow-up-right';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import AtlaskitDatabaseIcon from '@atlaskit/icon/core/database';
import NumberIcon from '@atlaskit/icon/core/hashtag';
import ImageIcon from '@atlaskit/icon/core/image';
import LinkIcon from '@atlaskit/icon/core/link';
import ListBulletedIcon from '@atlaskit/icon/core/list-bulleted';
import PageIcon from '@atlaskit/icon/core/page';
import PersonIcon from '@atlaskit/icon/core/person';
import NewTagIcon from '@atlaskit/icon/core/tag';
import TaskIcon from '@atlaskit/icon/core/task';
import WorkItemIcon from '@atlaskit/icon/core/work-item';
import { DatabaseFieldType } from '@databases/types/database';
import { type ComponentType } from 'react';

import { AiSummaryIcon } from './AiSummaryIcon.tsx';

export interface DatabaseFieldIconType {
  readonly icon: ComponentType<NewCoreIconProps>;
}

/**
 * Static field-type icon mapping without feature checks, hooks, or exposure events.
 */
export const FIELD_ICONS: { [Type in DatabaseFieldType]: DatabaseFieldIconType } = {
  [DatabaseFieldType.TEXT]: { icon: AlignTextLeftIcon },
  [DatabaseFieldType.AI_SUMMARY]: { icon: AiSummaryIcon },
  [DatabaseFieldType.ATTACHMENT]: { icon: ImageIcon },
  [DatabaseFieldType.NUMBER]: { icon: NumberIcon },
  [DatabaseFieldType.DATE]: { icon: CalendarIcon },
  [DatabaseFieldType.SELECT]: { icon: NewTagIcon },
  [DatabaseFieldType.USER]: { icon: PersonIcon },
  [DatabaseFieldType.HYPERLINK]: { icon: LinkIcon },
  [DatabaseFieldType.CHECKBOX]: { icon: TaskIcon },
  [DatabaseFieldType.PAGE_LINK]: { icon: PageIcon },
  [DatabaseFieldType.PAGE_STATUS]: { icon: CheckCircleIcon },
  [DatabaseFieldType.PAGE_LABELS]: { icon: LozengeIcon },
  [DatabaseFieldType.PAGE_DETAILS]: { icon: BookOpenIcon },
  [DatabaseFieldType.ENTRY_LINK]: { icon: AtlaskitDatabaseIcon },
  [DatabaseFieldType.ENTRY_DETAILS]: { icon: ListBulletedIcon },
  [DatabaseFieldType.BACKLINK]: { icon: AtlaskitDatabaseIcon },
  [DatabaseFieldType.JIRA_ISSUE]: { icon: WorkItemIcon },
  [DatabaseFieldType.JIRA_ISSUE_DETAILS]: { icon: BookOpenIcon }
};

export { ArrowUpRightIcon, ArrowsDiagonalUpRightDownLeftIcon };
